@let isShiftDraggableFeatureFlag =
  'portal-shift-timeline-shift-drag-drop' | featureFlagPure | async;
@let isLoadingValidations =
  shiftCardTooltipStateService.isLoadingValidationsForUser$ | async;
@let isShiftValid = shiftCardTooltipStateService.isShiftValid$ | async;
@let isLoadingValidationsError =
  shiftCardTooltipStateService.isLoadingValidationsError$ | async;
@let hasShiftBeenValidated =
  shiftCardTooltipStateService.hasShiftBeenValidated$ | async;
@let isShiftSelected =
  shiftMultiSelectHelperService.selectedShifts$
    | isShiftSelected: shift.id
    | async;
@let heightClass = isMoreThanOneAssignment ? 'h-50' : 'h-100';
@let isShiftDragging = draggingItemId === shift.id;
@let isShiftDraggableCheck = shift | isShiftDraggable;
@let hasShiftUpdatePermissions =
  can(RoleAction.Update, RolePermissionSubject.Shift);
@let hasProjectReadPermission =
  can(RoleAction.Read, RolePermissionSubject.Project);
@defer (on hover) {
  <wilson-shift-validation-tooltip-wrapper
    [showShiftValidation]="true"
    [plannedShiftStartDateTime]="shift.startDatetime"
    [plannedShiftEndDateTime]="shift.endDatetime"
    [accurateShiftStartDateTime]="shiftStartDetail.date"
    [accurateShiftEndDateTime]="shiftEndDetail.date"
    [shiftStartTimeDifference]="shiftStartDetail.timeDifference"
    [shiftEndTimeDifference]="shiftEndDetail.timeDifference"
    [shiftStartTimeType]="shiftStartDetail.type"
    [shiftEndTimeType]="shiftEndDetail.type"
    [plannedStartLocation]="shift.startLocation"
    [plannedEndLocation]="shift.endLocation"
    [reportedStartLocation]="shift.reportedStartLocation"
    [reportedEndLocation]="shift.reportedEndLocation"
    [displayTooltip]="isTooltipVisible"
    [heightClass]="heightClass"
  >
    <ng-container *ngTemplateOutlet="shiftCard"></ng-container>
  </wilson-shift-validation-tooltip-wrapper>
} @placeholder {
  <div [ngClass]="heightClass">
    <ng-container *ngTemplateOutlet="shiftCard"></ng-container>
  </div>
}
@if (isMoreThanOneAssignment) {
  <div
    class="h-50 w-100 assignments-icon"
    [class.pt-1]="!isMinimalMode"
    nz-dropdown
    nzTrigger="click"
    (nzVisibleChange)="changeMenuVisibility.emit(!menuVisible)"
    [nzDropdownMenu]="contextMenuTemplate"
    [nzVisible]="menuVisible"
    [nzOverlayStyle]="{ 'max-width': '150px' }"
    [class.low-opacity]="isShiftDragging || stackHighlightIds.length === 0"
  >
    @if (areShiftsValid) {
      <img
        src="assets/img/shift-timeline/multiple-assignments-valid.svg"
        class="snapping-icon w-100 h-100"
        draggable="false"
      />
    } @else {
      <img
        src="assets/img/shift-timeline/multiple-assignments-invalid.svg"
        class="snapping-icon w-100 h-100"
        draggable="false"
      />
    }
  </div>
}
<ng-template #shiftCard>
  @let presenceBorderColor = shift.id | shiftPresenceBorderColor | async;

  <div
    [attr.data-test-id]="
      'wilson-timeline-cell-view-shift:shift-card:' + shift.name
    "
    [class]="
      'timeline-shift-accent-border' +
      ' ' +
      'timeline-shift-type--' +
      shift.shiftCategoryId +
      ' ' +
      'timeline-shift-project--' +
      hasProjectReadPermission +
      '--' +
      project?.status
    "
    [ngStyle]="
      {
        shiftCategoryId: shift.shiftCategoryId,
        shiftColorOption: shiftColorOption,
        label: label,
        project: project,
        hasProjectReadPermission: hasProjectReadPermission,
        presenceBorderColor: presenceBorderColor,
      } | shiftCardColorStyle
    "
    class="w-100 h-100 rounded-1 stack-card"
    [ngClass]="
      isShiftModified
        ? isMoreThanOneAssignment
          ? 'modified-cell'
          : 'modified'
        : ''
    "
    [class.group-item]="
      !isShiftSelected &&
      groupItemsSelectionHelperService.groupedShiftIds().has(shift.id)
    "
    [class.selected]="isShiftSelected"
    [class.is-not-draggable]="
      !(
        isShiftDraggable &&
        isShiftDraggableFeatureFlag &&
        isShiftDraggableCheck
      )
    "
    [class.low-opacity]="
      isShiftDragging || !stackHighlightIds.includes(shift.id)
    "
    [draggable]="
      isShiftDraggable && isShiftDraggableFeatureFlag && isShiftDraggableCheck
    "
    (click)="
      isSelectionEnabled &&
        shiftSelected.emit({ event: $event, shiftId: shift.id })
    "
    (dragstart)="
      dragStarted.emit({
        shift,
        isAssignmentMode: !!isAssignmentMode,
        hasShiftUpdatePermissions: !!hasShiftUpdatePermissions,
      })
    "
    (dragend)="dragEnded.emit()"
  >
    <ng-container
      *ngTemplateOutlet="
        deferredAssignmentShiftCardCellViewHelperService.getPreviewTemplateContent();
        context: {
          shift: shift,
          showShiftValidation: true,
          isLoadingValidations: !!isLoadingValidations,
          hasShiftBeenValidated: !!hasShiftBeenValidated,
          isShiftValid: $any(isShiftValid),
          isLoadingValidationsError: !!isLoadingValidationsError,
          isShiftCompleted:
            shift.operationalStatus === OperationStatus.Completed,
          isShiftStarted: shift.operationalStatus === OperationStatus.Ongoing,
          shiftStartDetail: shiftStartDetail,
          shiftEndDetail: shiftEndDetail,
          loadIconsImmediately: true,
        }
      "
    ></ng-container>
  </div>
</ng-template>
